module.exports = __webpack_public_path__ + "media/images/facebook_cover_image-41883ea87802b9610c19381bbe51f27e.png";